import { Logo } from "@/components/Layout";
import MuseCollage from "@/components/MuseCollage";

export default function AuthShell({ eyebrow, title, subtitle, children }) {
  return (
    <div className="min-h-screen md:grid md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-center p-10 lg:p-14 gap-8">
        <MuseCollage />
        <div>
          <p className="eyebrow mb-3">For creators of AI muses</p>
          <p className="font-display text-4xl">She looks the same<br /><span className="accent-text">in every frame.</span></p>
        </div>
      </div>
      <div className="flex flex-col px-6 py-10 md:px-16 md:py-16 justify-center bg-white md:border-l border-[#F0EAF7]">
        <Logo className="mb-14" />
        <div className="w-full max-w-sm fade-up">
          <p className="eyebrow mb-3">{eyebrow}</p>
          <h1 className="text-4xl sm:text-5xl mb-3">{title}</h1>
          {subtitle && <p className="muted text-sm mb-10">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
